export default "__VITE_ASSET__CEtqUmij__"